module.exports = __webpack_public_path__ + "static/media/editorialCodeDarkMobile.e36d3dbe.png";